module.exports = __webpack_public_path__ + "img/bran_luebbe.e98ba4c5.png";